import {
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Chip,
} from "@mui/material";

export function TopCountriesList({ data }) {
  return (
    <List disablePadding sx={{ width: "95%" }}>
      {data.map(({ name, iso, count }) => (
        <ListItem
          key={iso}
          sx={{
            "&:hover": { backgroundColor: "rgba(0,0,0,0.04)" },
            borderRadius: 1,
            mb: 1,
            px: 2,
          }}
        >
          <ListItemAvatar>
            <Avatar
              src={`https://flagcdn.com/${iso.toLowerCase()}.svg`}
              alt={`Flag of ${name}`}
              variant="square"
              sx={{
                width: 32,
                height: 24,
                mr: 2,
                boxShadow: "1px 1px 1px rgba(87, 87, 87, 0.35)",
              }}
            />
          </ListItemAvatar>
          <ListItemText
            primary={name}
            primaryTypographyProps={{
              fontWeight: 500,
              fontSize: "1.3rem",
            }}
          />
          <Chip
            label={`${count} airports`}
            size="small"
            sx={{
              backgroundColor: "var(--color-primary)",
              color: "white",
              fontWeight: 600,
              fontSize: "1rem",
            }}
          />
        </ListItem>
      ))}
    </List>
  );
}
